import { getOperationName } from "../../utilities/index.js";
export function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/utils/transformOperation.js
// module id = ./node_modules/@apollo/client/link/utils/transformOperation.js
// module chunks = 53 54